import style from "./style.scss";
import { mergeClasses } from "../helpers";
import Image from "../../components/image";
import Link from "../../components/link";

const PhotoListItem = ({
  href,
  affiliate = null,
  affiliateData = null,
  external = false,

  buttonText = null,
  buttonIcon = null,
  buttonSecondary = null,
  buttonsData = null,
  // // Example data
  // [
  //   {
  //     text: "EcoFlow",
  //     icon: "EcoFlow",
  //     //affiliateData: affiliateMerchants.ecoflow,
  //     href: "https://us.ecoflow.com/products/800w-alternator-charger",
  //   },
  //   {
  //     text: "Amazon",
  //     icon: "Amazon",
  //     secondary: true,
  //     affiliate: "https://amzn.to/3N4b6p1",
  //     href: "https://www.amazon.com/dp/B0DSBZVPS6/",
  //   },
  // ]

  title,
  titleSuffix = null,
  description,

  img,
  border = false,
  shadow = false,
  background = true,

  large = false,
}) => {
  let finalButtonData = buttonsData;
  if (!finalButtonData && href) {
    finalButtonData = [
      {
        text: buttonText ? buttonText : "Visit Link",
        href,
        affiliate,
        affiliateData,
        external,
        icon: buttonIcon,
        secondary: buttonSecondary,
      },
    ];
  }

  return (
    <div
      class={mergeClasses([
        style.photoListItem,
        large == true ? style.large : null,
      ])}
    >
      <div
        class={mergeClasses([
          style.imgWrapper,
          border == true ? style.border : null,
          shadow == true ? style.shadow : null,
          background == true ? style.background : null,
        ])}
      >
        {img && (
          <Image
            src={img}
            alt={title}
            border={false}
            shadow={false}
            background={false}
            showAlt
            buttonsData={finalButtonData}
          />
        )}
      </div>
      <div class={style.text}>
        {href ? (
          <Link
            class={style.title}
            external={external}
            affiliateData={affiliateData}
            affiliate={affiliate}
            href={href}
          >
            {title}
          </Link>
        ) : (
          <span class={style.title}>{title}</span>
        )}
        {titleSuffix ? ` ${titleSuffix}` : null}
        <div class={style.description}>{description}</div>
      </div>
    </div>
  );
};

export default PhotoListItem;
